import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

import { ref, watch } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoModal',
  props: {
    modelValue: { type: Boolean },
    title: { default: "" },
    modalWidth: { default: "50%" },
    modalHeight: { default: "" },
    slotTextAreaHeight: { default: "" }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props
const status = ref(false as boolean)

watch(() => props.modelValue, (bool) => {
  status.value = bool
})

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    id: "modal",
    modelValue: status.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((status).value = $event)),
    width: props.modalWidth,
    height: props.modalHeight,
    class: "modal-class",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        style: {"background-color":"white"},
        class: "w-100"
      }, {
        default: _withCtx(() => [
          (props.title)
            ? (_openBlock(), _createBlock(_component_v_card_title, {
                key: 0,
                class: "fs-4 fw-bold grey lighten-2 mx-auto mt-1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.title), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_card_text, {
            style: _normalizeStyle(`height: ${props.slotTextAreaHeight}`)
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "text")
            ]),
            _: 3
          }, 8, ["style"]),
          _renderSlot(_ctx.$slots, "footer")
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["modelValue", "width", "height"]))
}
}

})